import { loadState, saveState } from '../utils/LocalStorage'
import { setSession, removeSession, logout as auth0Logout } from '../utils/AuthService'
import CONFIG from '../config'

// There are three possible states for our login
// process and we need actions for each of them
import {
  LOGIN_SUCCESS,
  LOGOUT_REQUEST, LOGOUT_RESPONSE,
  LOAD_AUTH,
} from '../constants'

import { listOrganizations } from './organization'

export function loginSuccess(authResult) {
  return (dispatch) => {
    const { accessToken, idToken, expiresIn } = authResult
    const expiresAt = authResult.expiresAt || (expiresIn * 1000) + Date.now()
    const metadata = authResult.idTokenPayload['https://blokable.com'] || {}
    const envOverride = (metadata && metadata[CONFIG.env]) || {}
    delete metadata.production
    delete metadata.qa
    delete metadata.dev
    const auth = {
      accessToken, idToken, expiresAt, ...metadata, ...envOverride,
    }

    saveState('auth', auth)
    setSession(auth)

    dispatch({
      type: LOGIN_SUCCESS,
      auth,
    })
    dispatch(listOrganizations())
  }
}

export function loadAuth() {
  return (dispatch) => {
    const auth = loadState('auth')
    if (auth) {
      setSession(auth)

      dispatch({ type: LOAD_AUTH, auth })
      dispatch(listOrganizations())
    }
  }
}

function requestLogout() {
  return {
    type: LOGOUT_REQUEST,
  }
}

function receiveLogout() {
  return {
    type: LOGOUT_RESPONSE,
  }
}

// Logs the user out
export function logout() {
  return (dispatch) => {
    dispatch(requestLogout())
    saveState('auth')
    removeSession()
    auth0Logout()
    dispatch(receiveLogout())
  }
}
